import * as Event from '../tools/Event';
import { scrollTo } from '../tools/utils';
import { MQ } from '../tools/MQ';


export const init = () => {
	const elements = [...document.querySelectorAll('.js-years')];
	const MENU_ATTR = 'data-menu';
	const HIDDEN_ATTR = 'aria-hidden';

	const init = (element) => {
		const prev = element.querySelector('.link-nav--prev');
		const next = element.querySelector('.link-nav--next');
		const prevLabel = prev.querySelector('.link-nav__label');
		const nextLabel = next.querySelector('.link-nav__label');
		const items = [...element.querySelectorAll(`[${MENU_ATTR}]`)];
		const itemsNumber = items.length;
		let lastItem = items.filter((item) => item.getAttribute(HIDDEN_ATTR) !== 'true');
		let lastIndex = items.indexOf(lastItem[0]);

		const getIndex = (step) => (lastIndex + step + itemsNumber) % itemsNumber;

		const setFocus = (element) => {
			setTimeout(() => {
				element.focus();
			}, 100);
		};

		const scrollToTop = (scrollable) => {
			if (!scrollable) return;

			scrollable.scrollTop = 0;


			if (scrollable.getBoundingClientRect().top < 0 && MQ('tabletMin')) {
				scrollTo(scrollable)
					.then(() => setFocus(scrollable));
			} else {
				setFocus(scrollable);
			}
		};

		const setVisibility = (lastIndex) => (item, index) => {
			if (index === lastIndex) {
				item.removeAttribute(HIDDEN_ATTR);

				return;
			}

			item.setAttribute(HIDDEN_ATTR, 'true');
		};

		const setNavLabel = (item, label) => item.textContent = label;

		const goTo = (step) => {
			if (itemsNumber <= 2) {
				switch (step) {
					case -1:
						lastIndex = 0;
						break;
					case 1:
						lastIndex = 1;
						break;
					default:
						break;
				}
			} else {
				lastIndex = getIndex(step);
				const prevItem = items[getIndex(-1)];
				const nextItem = items[getIndex(1)];

				setNavLabel(prevLabel, prevItem.getAttribute(MENU_ATTR));
				setNavLabel(nextLabel, nextItem.getAttribute(MENU_ATTR));
			}

			lastItem = items[lastIndex];
			const scrollable = lastItem.querySelector('.scroll__content');

			scrollToTop(scrollable);
			items.forEach(setVisibility(lastIndex));
		};

		Event.on(next, 'click', (event) => {
			event.preventDefault();
			goTo(1);
		});

		Event.on(prev, 'click', (event) => {
			event.preventDefault();
			goTo(-1);
		});
	};


	elements.forEach(init);
};
